// src/pages/Appointments/i18n/appointments.en.js

export const appointmentsEnTranslations = {
  menu: {
    groups: {
      appointments: {
        label: "Appointments",
        description: "Customer appointments and visit tracking",
      },
    },
    items: {
      appointments_dashboard: "Appointments Dashboard",
      book_appointment: "Book Appointment",
      appointment_calendar: "Calendar View",
      todays_appointments: "Today's Appointments",
      upcoming_appointments: "Upcoming",
      active_visits: "Active Visits",
      pending_approvals: "Pending Approvals",
      all_appointments: "All Appointments",
      appointment_analytics: "Analytics",
    },
    descriptions: {
      appointments_dashboard: "Overview of appointments and visit status",
      book_appointment: "Schedule new customer appointment",
      appointment_calendar: "View appointments in calendar format",
      todays_appointments: "View and manage today's appointments",
      upcoming_appointments: "Appointments for next 7 days",
      active_visits: "Currently checked-in customers",
      pending_approvals: "Appointments awaiting approval",
      all_appointments: "View and manage all appointments",
      appointment_analytics: "Appointment trends and analytics",
    },
    quick_access: {
      book_appointment: "Book Now",
      todays_appointments: "Today",
    },
  },

  appointments: {
    status: {
      scheduled: "Scheduled",
      confirmed: "Confirmed",
      pending: "Pending",
      in_progress: "In Progress",
      completed: "Completed",
      cancelled: "Cancelled",
      no_show: "No Show",
      rescheduled: "Rescheduled",
    },
    visit: {
      check_in: "Check In",
      check_out: "Check Out",
      start_consultation: "Start Consultation",
      complete_visit: "Complete Visit",
      duration: "Duration",
      waiting_time: "Waiting Time",
    },
    form: {
      customer_name: "Customer Name",
      phone: "Phone Number",
      email: "Email",
      appointment_date: "Appointment Date",
      appointment_time: "Appointment Time",
      branch: "Branch",
      service_type: "Service Type",
      notes: "Notes",
      reminder_preference: "Reminder Preference",
    },
    actions: {
      book: "Book Appointment",
      reschedule: "Reschedule",
      cancel: "Cancel",
      confirm: "Confirm",
      view_details: "View Details",
      edit: "Edit",
      delete: "Delete",
    },
    messages: {
      booking_success: "Appointment booked successfully",
      reschedule_success: "Appointment rescheduled successfully",
      cancel_success: "Appointment cancelled",
      check_in_success: "Customer checked in successfully",
      complete_success: "Visit completed successfully",
    },
  },
};

// Also export as default for the loader
export default appointmentsEnTranslations;
